/**
 * Created by coolguy on 2017/4/17.
 */
import moment from 'moment';
import AjaxAction from '../actions/AjaxAction';
import { roleList, wholeRoleList } from '../defaultData';
import { style } from './image';
//从list中找keyName值为key的obj
export let findObjByKey = (list, key, keyName = "key") => {
  if (!list) {
    return null;
  }
  return list.find((v) => {
    return v[keyName] === key;
  })
};
export let convertLongToMoment = (longTime) => {
  return moment(longTime - 0, "YYYY-MM-DD");
};

const defaultRemoveType = {
  emptyString: true, //移除空串
  nil: true,// 移除null
  number0: true, //移除数字0
  stringNumber0: false, //移除掉"0"

}
// 移除掉对象中空的部分，铜鼓配置项可以选择不移除部分空
export const removeEmpty = (obj, removeTypes = {}) => {
  let filtered = {};
  const finalTypes = { ...defaultRemoveType, ...removeTypes }
  for (let x in obj) {
    const value = obj[x];
    const { emptyString, nil, number0, stringNumber0 } = finalTypes;
    if (value === undefined) {
      continue;
    }
    if (emptyString && value === '') {
      continue;
    }
    if (nil && value === null) {
      continue;
    }
    if (number0 && value === 0) {
      continue;
    }
    if (stringNumber0 && value === '0') {
      continue;
    }
    filtered[x] = value;
  }
  return filtered;
}

export const parseJSONByKey = (source, key) => {
  if (source) {
    if (typeof source[key] == 'string') {
      return parseJSON(source[key]);
    }
    return source[key];
  }
  return null;
};

export const parseJSON = (str) => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return null;
  }
}

export const isElectron = function () {
  const userAgentInfo = navigator.userAgent;
  var Agents = ["JfotoElectronManager"];
  var flag = false;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = true;
      break;
    }
  }
  return flag;
};

export let unique = (arr, func) => {
  for (var i = 0; i < arr.length; i++) {
    var it = arr[i];
    for (var j = arr.length - 1; j > i; j--) {
      var bool = false;
      if (func) {
        bool = func(arr[j], it);
      } else {
        bool = arr[j] == it;
      }
      if (bool) {
        arr.splice(j, 1);
      }
    }
  }
  return arr;
};

export let filterToQuery = (list, myInfo) => {
  if (list && list.length) {
    return new Promise((resolve) => {
      var obj = {};
      var promises = list.map(it => {
        return (new Promise((reso, rej) => {
          var key = it.key;
          var value = it.value;

          if (value && typeof value == 'object' && value._isAMomentObject) {
            value = Math.floor(value.toDate().getTime() / 1000) * 1000;
          }

          if (key == 'price') {
            value *= 100;
            reso({ it, key, value });
          }
          else if (value == '********') {
            var opers = (myInfo.oper || "").split(',');
            var ignore = (opers.find(o => o == 'admin' || o == 'finance')) || (!window.actionFor('order-all', 'boolean'));
            if (ignore) {
              rej();
            }
            else if (key == 'orderarea') {
              // 此处要异步获取
              // value = myInfo.department;
              AjaxAction.userDepartment()().then(data => {
                value = unique(data.map(it => {
                  if (it.tallyarea * 1) {
                    return it.id;
                  }
                  return null;
                }).filter(it => !!it));
                reso({ it, key, value });
              });
            }
            else if (key == 'adminids') {
              value = myInfo.id;
              reso({ it, key, value });
            }
            else if (key == 'department') {
              // 此处要异步获取
              var pro = AjaxAction.userDepartment()();
              pro.then(data => {
                value = unique(data.map(it => it.id));
                reso({ it, key, value });
              });
              // value = myInfo.department;
            } else {
              reso({ it, key, value });
            }
          }
          else {
            reso({ it, key, value });
          }
        })).then((data) => {
          let { it, key, value } = data;

          if (it.oper != '=') {
            key += `[${it.oper}]`;
          }

          if (obj[key]) {
            obj[key] = [obj[key]].concat(value);
          } else {
            obj[key] = value;
          }

          return data;
        }).catch(e => {
          console.log(e);
        });
      });

      Promise.all(promises).then(() => {
        resolve(obj);
      });
    });
  } else {
    return new Promise((resolve) => resolve({}));
  }
};
export let cross = (source, target) => {
  let flag = false;
  for (let i = 0; i < source.length; i++) {
    if (target.indexOf(source[i]) > -1) {
      flag = true;
      break;
    }
  }

  return flag;
};
export let isWeb = () => {
  var userAgentInfo = navigator.userAgent;
  var Agents = ["Android", "iPhone",
    "SymbianOS", "Windows Phone",
    "iPad", "iPod"];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  if (flag == true) {
    // 判断一下是不是有微信及企业微信的PC端情况
    if (userAgentInfo.indexOf('MicroMessenger') > -1) {
      if (window.screen.width < 912) {
        flag = false;
      }
    }
  }

  return flag;
};

export let sleep = async (time) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, time);
  });
};

export let findTreeByRoad = (arr, target) => {
  if (target && target.length && target[0] * 1 == 0) {
    target = target.slice(1);
  }

  let result = null;

  let deep = function (list, id) {
    var exist = (list || []).filter(it => it.id == id);
    if (exist && exist.length) {
      exist = exist[0];
      if (target.length) {
        deep(exist.children || [], target.shift());
      } else {
        result = exist;
      }
    }
  };

  deep(arr, target.shift());

  return result;
};

export let findTreeByTarget = (arr, target) => {

};

const PHOTO_TARGETS = [
  '平台带单（4小时）',
  '平台带单（8小时）',
  '平台带单（12小时）',
  '摄影师合作版本相册（含修图，4小时）',
  '摄影师合作版本相册（含修图，8小时）',
  '摄影师合作版本相册（含修图，12小时）',
  '照片直播（4小时）',
  '照片直播（8小时）',
  '照片直播（12小时）',
  '照片直播4小时',
  '照片直播8小时',
  '照片直播12小时'
];

export let countProductSets = (products) => {
  var count = 0;
  const PHOTO_COUNT_TARGET = PHOTO_TARGETS.filter(it => it.indexOf('平台带单') < 0);

  (products || []).forEach(it => {
    PHOTO_COUNT_TARGET.forEach(key => {
      if ((it.name || "").indexOf(key) > -1) {
        count += Number(it.number);
      }
    });
  });
  return count;
}

export const fixedLength = (val, prefix = '0', len = 2) => {
  val = val + '';
  while (val && val.length < len) {
    val = prefix + val;
  }
  return val;
};

export const moneyRender = (money) => ((money || 0) / 100).toFixed(2);

// 是否是HTML的简短判断，欢迎指出问题
// 直接就判断失败了好么。。暂时不用这方法，没时间了，如果是Master发布的评论，全用html显示 --- 20190228 -lizh
// 疯狂打脸，判断是对了的   --- 20190228 -lizh -review
export const isHtml = (string) => /^<(\w+).*?(<\/\1>|\/>)$/g.test(string);

export const getRoleObjs = (roleArr) => {
  let objArr = [];
  roleArr.forEach((role) => {
    const theRole = wholeRoleList.find(oneRole => oneRole.key === role);
    if (!theRole) {
      console.warn('role name is not valid', role);
    } else {
      objArr.push(theRole);
    }
  })
  return objArr;
}

export const getRoleNames = (roleArr) => {
  return getRoleObjs(roleArr).map(role => role.name);
}

export const uuid = (len = 8, decimal = 32) => {
  var result = '';
  while (len) {
    result += Math.floor(Math.random() * decimal).toString(decimal);
    len--;
  }
  return result;
}

export const byteLength = (val) => {
  var matches = val.match(/[^\x00-\xff]/g);
  return val.length + (!matches ? 0 : matches.length);
}


export const byteSubstring = (val, len) => {
  let total = len;
  for (var i = 0; i < val.length; i++) {
    var char = val[i];
    if (char.match(/[^\x00-\xff]/)) {
      total -= 2;
    } else {
      total -= 1;
    }

    if (total <= 0) {
      break;
    }
  }

  return val.substring(0, i);
}

export const getPageComponent = (container, result, type) => {
  container.forEach(it => {
    if (it.template instanceof Array) {
      result = getPageComponent(it.template, result, type);
    }
    else if (it.list instanceof Array) {
      result = getPageComponent(it.list, result, type);
    }
    else if (it.children instanceof Array) {
      result = getPageComponent(it.children, result, type);
    }
    else {
      if (type.indexOf(it.type) > -1) {
        result.push(it);
      }
    }
  });

  return result;
}

export const resetPageComponent = (container) => {
  container = (container || []).map(it => {
    if (it.template instanceof Array) {
      it.template = resetPageComponent(it.template);
    }
    else if (it.list instanceof Array) {
      it.list = resetPageComponent(it.list);
    }
    else if (it.children instanceof Array) {
      it.children = resetPageComponent(it.children);
    }
    else if (typeof it.cid === 'string') {
      it = Object.assign({}, it, {
        cid: uuid(8, 16)
      });
    }

    return it;
  });

  return container;
};

export const realGalleryPath = (galleryid) => {
  if (galleryid * 1 < 1000000) {
    return "/page/gallery/list/" + galleryid;
  } else {
    return "/page/gallery/image/" + galleryid;
  }
}

export const customISOString = (data) => {
  function pad(number) {
    if (number < 10) {
      return '0' + number;
    }
    return number;
  }

  return data.getUTCFullYear() +
    '-' + pad(data.getUTCMonth() + 1) +
    '-' + pad(data.getUTCDate()) +
    'T' + pad(data.getUTCHours()) +
    ':' + pad(data.getUTCMinutes()) +
    ':' + pad(data.getUTCSeconds()) +
    'Z';
};

export const downloadCSV = (data, name) => {
  // “\ufeff” BOM头
  var uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(data);
  var downloadLink = document.createElement("a");
  downloadLink.href = uri;
  downloadLink.download = (name + ".csv") || "temp.csv";
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};

export const downloadText = (data, name) => {
  // “\ufeff” BOM头
  var uri = 'data:text/plain;charset=utf-8,\ufeff' + encodeURIComponent(data);
  var downloadLink = document.createElement("a");
  downloadLink.href = uri;
  downloadLink.download = (name + ".txt") || "temp.txt";
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};

export const checkFileExist = async (dictoryHandle, fileName) => {
  try {
    console.log(`checkFileExist: ${fileName}`);
    const fileHandle = await dictoryHandle.getFileHandle(fileName);
    return true;
  } catch (e) {
    console.log(`checkFileExist: ${fileName} 不存在`);
    return false;
  }
};

export const saveFileHandle = async (dictoryHandle, fileName, options) => {
  console.log(`开始保存文件`, fileName);
  if (options && options.skip) {
    const existResult = await checkFileExist(dictoryHandle, fileName);
    if (existResult) {
      return true;
    }
  }

  try {
    const fileHandle = await dictoryHandle.getFileHandle(fileName, {
      create: true
    });
    const writable = await fileHandle.createWritable();

    try {

      // 根据配置读取文件
      let contents = null;
      if (options) {
        const { mimeType, sourceType, source } = options;
        console.log(sourceType, source);
        if (sourceType == 'url') {
          if (options && options.logger) {
            options.logger(`开始抓取: ${source}`);
          }

          contents = await Promise.race([
            window.fetch(source).then(res => res.blob()),
            new Promise((resolve, reject) => {
              setTimeout(() => {
                reject(new Error('Timeout'));
              }, 60 * 3 * 1000);
              // 3分钟超时 
            })
          ]);

          if (options && options.logger) {
            options.logger(`抓取成功: ${contents ? contents.size : 0}, ${source}`);
          }
        }
      }

      if (contents) {
        await writable.write(contents);
      }
      await writable.close();
      return true;
    } catch (e) {
      console.error(e);
      console.log(`抓取失败: ${fileHandle.name}, ${e.message}`);
      if (options && options.logger) {
        options.logger(`抓取失败: ${fileHandle.name}, ${e.message}`);
      }
      // 删除刚才创建的文件
      await writable.close();
      await fileHandle.remove();
      return false;
    }
  } catch (e) {
    console.error(e);
    console.log(`创建文件失败: ${fileName}, ${e.message}`);
    return false;
  }
};

export const formatDateRange = (start_time, end_time) => {
  let start = moment(start_time);
  let end = moment(end_time);
  if (start.isValid()) {
    if (end.isValid()) {
      if (start.format('YYYYMMDD') == end.format('YYYYMMDD')) {
        return start.format('YYYY.MM.DD HH:mm') + '-' + end.format('HH:mm');
      } else {
        return start.format('YYYY.MM.DD') + '-' + end.format('MM.DD');
      }
    }
    return start.format('YYYY.MM.DD HH:mm');
  }

  return '--';
};

export const isFullScreen = function () {
  const isFullscreen =
    window.fullScreen ||
    document.mozFullscreenEnabled ||
    document.webkitIsFullScreen;
  return isFullscreen;
};

export const requestFullScreen = function (element) {
  element = element || document.documentElement;
  const requestMethod =
    element.requestFullscreen || //W3C
    element.webkitRequestFullScreen || //Chrome等
    element.mozRequestFullScreen || //FireFox
    element.msRequestFullScreen; //IE11
  if (requestMethod) {
    requestMethod.call(element);
  } else if (typeof window.ActiveXObject !== 'undefined') {
    const wscript = new window.ActiveXObject('WScript.Shell');
    if (wscript !== null) {
      wscript.SendKeys('{F11}');
    }
  }
};

export const drawCanvas = (width, height) => {
  let canvas = window.document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  let context = canvas.getContext('2d');

  context.appendWatermark = async (watermark) => {
    const { icon, percent, align, h, v } = watermark;
    const image = await new Promise((resolve) => {
      let dom = new Image();
      dom.onload = () => {
        resolve(dom);
      };
      dom.setAttribute('crossOrigin', 'Anonymous');
      dom.src = style(icon, 'original');
    });

    // 等比例放大，然后再考虑使用哪个边来做缩放
    let vPercent = height / image.height;
    let hPercent = width / image.width;
    let newWidth = 0;
    let newHeight = 0;
    if (vPercent < hPercent) {
      newHeight = Math.round(height * percent / 100);
      newWidth = Math.round(newHeight / image.height * image.width);
    } else {
      newWidth = Math.round(width * percent / 100);
      newHeight = Math.round(newWidth / image.width * image.height);
    }

    // 其实是水印图片太小了
    // if(newWidth > image.width) {
    //   newWidth = image.width;
    //   newHeight = image.height;
    // }

    let x = 0;
    let y = 0;
    // 计算位置
    if (align == 'nw') {
      x = h;
      y = v;
    }
    if (align == 'north') {
      x = Math.round((width - newWidth) / 2);
      y = v;
    }
    if (align == 'ne') {
      x = Math.round(width - newWidth - h);
      y = v;
    }
    if (align == 'west') {
      x = h;
      y = Math.round((height - newHeight) / 2);
    }
    if (align == 'center') {
      x = Math.round(width - newWidth);
      y = Math.round((height - newHeight) / 2);
    }
    if (align == 'east') {
      x = Math.round(width - newWidth - h);
      y = Math.round((height - newHeight) / 2);
    }
    if (align == 'sw') {
      x = h;
      y = Math.round(height - newHeight - v);
    }
    if (align == 'south') {
      x = Math.round((width - newWidth) / 2);
      y = Math.round(height - newHeight - v);
    }
    if (align == 'se') {
      x = Math.round(width - newWidth - h);
      y = Math.round(height - newHeight - v);
    }

    context.drawImage(image, 0, 0, image.width, image.height, x, y, newWidth, newHeight);

    return context;
  };

  context.appendImage = (image) => {

  };

  context.build = (mimeType) => {
    return canvas.toDataURL(mimeType);
  };

  return context;
}

export const isFunction = (func) => {
  return func && typeof func == 'function';
}


export const downloadByUrl = (url, name) => {
  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      const a = document.createElement("a");
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = name || "";
      a.click();
      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      console.error("Download error:", error);
    });
}


/**
 * 过滤树形数据, 如果子节点有匹配项, 那么其父节点也会被保留
 * @param treeData 原始树形数据
 * @param searchText 搜索文本
 * @param attr 属性名, 默认是 label, 也就是 item[attr] 是要匹配的文本
 * @returns {*}
 */
export const filterTreeDataAndKeepParent = (
  treeData,
  searchText,
  attr = "label"
) => {
  if (!searchText) {
    return treeData;
  }
  return treeData
    .map((item) => {
      const label = item[attr];
      const isMatch = label.indexOf(searchText) > -1;

      // 递归过滤子节点
      const filteredChildren = item.children
        ? filterTreeDataAndKeepParent(item.children, searchText, attr)
        : [];

      // 如果当前节点匹配或者子节点有匹配项，则保留该节点
      if (isMatch || filteredChildren.length > 0) {
        return {
          ...item,
          children: filteredChildren,
        };
      } else {
        return null;
      }
    })
    .filter(Boolean);
};

export const copyToClipboard = (txt) => {
  try {
    var textarea = document.createElement("textarea");
    textarea.value = txt;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  } catch (e) {

  }
}

// 从剪贴板中复制文本
export const copyFromClipboard = async (actionName) => {
  try {
    let text = await navigator.clipboard.readText();

    if (actionName) {
      if (text.indexOf(actionName) == 0) {
        const match = text.match(new RegExp(`^${actionName}:(.*):SUB_END:`));
        if (match) {
          const [all, href] = match;
          if (href && href !== window.location.href) {
            const jsonText = text.replace(match[0], '');
            try {
              const jsonData = JSON.parse(jsonText);
              return jsonData;
            } catch (e) {
              return "";
            }
          } else {
            return "";
          }
        }
      }
    }

    return text;
  } catch (e) {
    return "";
  }
};


// WEBPACK FOOTER //
// ./src/util/index.js